import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  permissions: [],
  loading: false,
  error: null,
  lastFetched: null,
}

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions(state, action) {
      state.permissions = action.payload
      state.error = null
      state.lastFetched = Date.now()
    },
    clearPermissions(state) {
      state.permissions = []
      state.error = null
      state.lastFetched = null
    },
    setPermissionsLoading(state, action) {
      state.loading = action.payload
    },
    setPermissionsError(state, action) {
      state.error = action.payload
      state.loading = false
    },
  },
})

export const {
  setPermissions,
  clearPermissions,
  setPermissionsLoading,
  setPermissionsError,
} = permissionsSlice.actions

export const selectPermissions = state => state.Permissions?.permissions ?? []

export const selectHasPermission = (state, categoryId, permissionId) => {
  const { Login } = state
  if (
    Login?.accountType === "superadmin" ||
    Login?.accountScope === "super_admin"
  ) {
    return true
  }
  const userRole = Login?.userRole
  if (userRole?.permissions) {
    const category = userRole.permissions.find(r => r.id === categoryId)
    if (category) {
      const perm = category.permissions?.find(p => p.id === permissionId)
      return !!(perm && perm.isEnabled)
    }
  }
  return false
}

export default permissionsSlice.reducer
